import axios from "axios";
import { requestInterceptor } from "./interceptors";

export const cmsApi = axios.create({
    baseURL: import.meta.env.VITE_CMS_API_URL,

    headers: {
        "Content-Type": "application/json",
    },
});

export const cmsApiFetcher = async (url: string, options: any) => {
    const response = await cmsApi(url, options);
    return response.data;
}


cmsApi.interceptors.request.use(requestInterceptor);